import { Component } from '@angular/core';

import { RendererBaseComponent } from 'sc-common/shared/table/body/renderers/renderer-base.component';

@Component({
    templateUrl: 'number-renderer.component.html',
    standalone: false
})
export class NumberRendererComponent extends RendererBaseComponent {

    constructor() {
        super();
    }
}
